var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTikTok = function SvgTikTok(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 477.709,
    height: 541.878,
    viewBox: "0 0 477.709 541.878",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "TikTok",
    d: "M222.23-15H340.354L340.229.123a106.452,106.452,0,0,0,1.63,19.426,107.542,107.542,0,0,0,47.266,70.232,106.279,106.279,0,0,0,58.849,17.749h15l.025,15V224.874l-14.964.036A224.5,224.5,0,0,1,340.23,197.731V349.38c-.027,73.634-46.378,140.436-115.338,166.234A177.509,177.509,0,0,1,28.769,465.9c-48.346-55.531-57.282-136.346-22.235-201.1a177.347,177.347,0,0,1,156.093-93.042h.011a178.462,178.462,0,0,1,24.421,1.688L200,175.246v123.4l-19.5-6.134A59.62,59.62,0,1,0,222.23,349.38Zm88.722,30H252.23V349.38a89.618,89.618,0,1,1-89.612-89.623q3.7,0,7.382.3V201.95q-3.692-.185-7.371-.186a147.553,147.553,0,1,0,147.6,147.61v-207.9l23.731,16.987A193.79,193.79,0,0,0,433,194.381v-57.67A135.988,135.988,0,0,1,372.727,114.9,137.637,137.637,0,0,1,312.346,24.93Q311.466,19.972,310.952,15Z",
    transform: "translate(14.709 15)",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTikTok);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TikTok.1358184ab3efe1683a61045336e0284e.svg";